import React from 'react';
import Declarations from '../../containers/dashboard/Declarations';

const DeclarationPage = () => {
  return (
    <div className="flex flex-wrap">
      <div className="w-full xl:12 mb-12 xl:mb-0 px-4">
        <Declarations />
      </div>
    </div>
  );
};

export default DeclarationPage;
